import { jsx, jsxs } from "react/jsx-runtime";
import { string, bool, func, oneOfType, element } from "prop-types";
import React, { useEffect, useRef, useContext } from "react";
import cx from "classnames";
import Label from "@ingka/label";
import { FormFieldContext } from "@ingka/form-field";
const propTypes = {
  /** Unique ID of the textarea field */
  id: string,
  /** Text that is passed to the Label component */
  label: oneOfType([string, element]),
  /** Prevents adding placeholder attribute on `<textarea>` */
  placeholder: string,
  /** Sets field as required and aria-required */
  req: oneOfType([bool, string, element]),
  /** Disabled state of the input field */
  disabled: bool,
  /** Optional function "onChange" */
  onChange: func,
  /** Value of textarea field, makes component Controlled */
  value: string,
  /** Default value of textarea field, makes component Uncontrolled */
  defaultValue: string,
  /** Id used on validation object prop for FormField component */
  describedById: string,
  /** Prefix all classes in every element with this string */
  prefix: string,
  /** Can be used to add classes to base HTML element. */
  className: string
};
const TextArea = (props) => {
  const {
    className,
    onChange,
    prefix = "",
    id,
    describedById,
    label = "Label",
    placeholder,
    disabled = false,
    req = false,
    ...other
  } = props;
  const { shouldValidate, valid, setCharacterCount } = useContext(FormFieldContext);
  const onChangeHandler = (e) => {
    if (setCharacterCount) {
      setCharacterCount(e.target.value.length);
    }
    if (onChange) {
      onChange(e);
    }
  };
  const { value, defaultValue } = other;
  let defaultCharacterCount = 0;
  if (value && value.length) {
    defaultCharacterCount = value.length;
  } else if (defaultValue && defaultValue.length) {
    defaultCharacterCount = defaultValue.length;
  }
  const baseClass = `${prefix}text-area`;
  useEffect(() => {
    if (setCharacterCount) {
      setCharacterCount(defaultCharacterCount);
    }
  }, [defaultCharacterCount]);
  const classes = cx(
    className,
    `${baseClass}`,
    shouldValidate && !valid && `${baseClass}--error`,
    shouldValidate && valid && `${baseClass}--success`,
    disabled && `${baseClass}--disabled`,
    `${prefix}label-wrapper ${prefix}label-wrapper--text-input`
  );
  const textarea = useRef();
  return /* @__PURE__ */ jsxs("div", { className: classes, children: [
    /* @__PURE__ */ jsx(Label, { prefix, htmlFor: id, label }),
    /* @__PURE__ */ jsxs("div", { className: `${baseClass}__wrapper`, children: [
      /* @__PURE__ */ jsx(
        "textarea",
        {
          ref: textarea,
          id,
          "aria-describedby": describedById,
          disabled,
          required: req,
          "aria-invalid": shouldValidate ? !valid : null,
          "aria-required": Boolean(req),
          onChange: onChangeHandler,
          ...other
        }
      ),
      /* @__PURE__ */ jsx("span", { className: `${baseClass}__border` })
    ] })
  ] });
};
TextArea.propTypes = propTypes;
var TextArea_default = TextArea;
export {
  TextArea_default as default
};
